import React from 'react';
import { componentService } from 'js/services/component.service';
import { Promotions } from 'js/components/main/Promotions';

export const BonusMultiview = React.lazy(() => import(/* webpackChunkName: "bonus-multi-view" */ './BonusMultiview'));

componentService.registerPageComponents({
    'bonus-multi-view':
        window.Playtech.Variables.useBetaPromotionsComponent
            ? Promotions
            : BonusMultiview
});
